import { cdnTemplate } from 'cdnPreprocessor';

export default [
  '$location', '$window',
  function FacebookShare ($location, $window) {
    return {
      restrict: 'C',
      replace: true,
      templateUrl: cdnTemplate('/social-share-button.html'),
      scope: true,
      link: (scope) => {
        scope.share = function FacebookShareCall () {
          $window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent($location.absUrl())}`, 'facebook', 'width=600,height=530');
        };
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/social-share/facebook.dir.js